import styled from '@emotion/styled'
import { useState } from 'react'
import { ReactComponent as CloseIcon } from 'shop/assets/icons/close.svg'

const DevInfoBanner = () => {
  const [showDevInfo, setShowDevInfo] = useState<boolean>(true)
  const gitBranchName = process.env.REACT_APP_GIT_BRANCH

  return (
    <>
      {showDevInfo && gitBranchName && (
        <DevInfoContainer data-testid='dev-info-banner'>
          <h3>{gitBranchName}</h3>
          <CloseButtonContainer
            data-testid='close-button'
            onClick={() => setShowDevInfo(false)}
          >
            <CloseIcon />
          </CloseButtonContainer>
        </DevInfoContainer>
      )}
    </>
  )
}

const DevInfoContainer = styled.div(({ theme }) => ({
  display: 'flex',
  bottom: 0,
  alignItems: 'center',
  justifyContent: 'center',
  position: 'fixed',
  width: '100%',
  height: '35px',
  zIndex: 301,
  backgroundColor: '#BF0000',
  opacity: 0.75,
  '& h3': {
    marginLeft: 'auto',
    fontWeight: 'normal',
    color: 'white'
  }
}))

const CloseButtonContainer = styled.div(() => ({
  marginLeft: 'auto',
  marginRight: '10px',
  order: 2,
  cursor: 'pointer',
  '> svg': {
    height: '25px',
    width: '25px',
    path: {
      fill: 'white'
    }
  }
}))

export default DevInfoBanner
